var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group)?_c('transition-group',_vm._b({staticClass:"c-transition",attrs:{"duration":_vm.groupDuration,"name":_vm.groupName},on:{"leave":_vm.leave}},'transition-group',_vm.$attrs,false),[_vm._t("default")],2):_c('transition',_vm._b({attrs:{"duration":_vm.duration,"name":_vm.name}},'transition',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }